import axios from 'axios'
import { metricUrl, cautionUrl, IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 查询告警类型
export function findStatus(params) {
  const url = metricUrl + '/device/selectStatus'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('综合视图', '查询告警类型', res)
    }
    return Promise.resolve(res.data)
  })
}

// 简化分页查询告警信息/驾驶舱、小程序
export function alertSimple(params) {
  const url = cautionUrl + '/alert/page/alert/simple'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('综合视图', '分页查询告警信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// IH5出勤统计
export function attendIH5(params) {
  const url = cautionUrl + '/attendance/statics'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('综合视图', 'IH5出勤统计', res)
    }
    return Promise.resolve(res.data)
  })
}

// 安卓出勤、活跃度统计
export function attendStatistics(params) {
  const url = IhLogUrl + '/statistics/attend/' + params.ouId
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('综合视图', ' 安卓出勤、活跃度统计', res)
    }
    return Promise.resolve(res.data)
  })
}
